import moment from 'moment';

// Constants
const PIXELS_PER_DIGIT = 24.2; // Approximate width in pixels per digit for input field sizing

export const getLastReading = (ammMeterReadingList, productId) => {
  return ammMeterReadingList
    .filter(
      (reading) =>
        (reading.customerReadType === 'Customer' || reading.customerReadType === 'Initial') &&
        reading.product.id === productId
    )
    .map((reading) => ({
      ...reading,
      readingdate: moment(reading.readingdate, 'YYYY-MM-DDTHH:mm:ssZ'),
    }))
    .sort((a, b) => (b.readingdate.isBefore(a.readingdate) ? -1 : 1))[0];
};

export const formatReadingDate = (date) => {
  // Note: moment.format('L') returns a locale-dependent date format (e.g., MM/DD/YYYY for en-US).
  return date ? date.format('L') : '';
};

export const generateReadingMask = (digitsCount) => {
  return '0'.repeat(digitsCount);
};

export const calculateReadingInputWidth = (digitsCount) => {
  return digitsCount * PIXELS_PER_DIGIT;
};
